import { IControlProps } from "../controlItem/ControlItemTypes";

// Multi-lingual support
import { t } from "i18next";

// Control list
export const getControls = (): IControlProps[] => [
  {
    type: "Section",
    label: t("masters.formbuilder.controlList.section"),
    icon: "icon-section",
  },
  {
    type: "Short Answer",
    label: t("masters.formbuilder.controlList.shortAnswer"),
    icon: "icon-shortanswer",
  },
  {
    type: "Long Answer",
    label: t("masters.formbuilder.controlList.longAnswer"),
    icon: "icon-longanswer",
  },
  {
    type: "Single Choice",
    label: t("masters.formbuilder.controlList.singleChoice"),
    icon: "icon-singlechoice",
  },
  {
    type: "Multiple Choices",
    label: t("masters.formbuilder.controlList.multipleChoices"),
    icon: "icon-multiplechoices",
  },
  {
    type: "File Upload",
    label: t("masters.formbuilder.controlList.fileUpload"),
    icon: "icon-fileupload",
  },
  {
    type: "Date Picker",
    label: t("masters.formbuilder.controlList.datePicker"),
    icon: "icon-datepicker",
  },
  {
    type: "Time Picker",
    label: t("masters.formbuilder.controlList.timePicker"),
    icon: "icon-timerpicker",
  },
  {
    type: "Range Scale",
    label: t("masters.formbuilder.controlList.rangeScale"),
    icon: "icon-rangescale",
  },
];

// Control labels enums
export enum EControlLabels {
  SHORT_ANSWER = "Short Answer",
  LONG_ANSWER = "Long Answer",
  SINGLE_CHOICE = "Single Choice",
  MULTIPLE_CHOICES = "Multiple Choices",
  FILE_UPLOAD = "File Upload",
  DATE_PICKER = "Date Picker",
  TIME_PICKER = "Time Picker",
  RANGE_SCALE = "Range Scale",
  SECTION = "Section",
}

// Control list props
export interface IControlListProps {
  disableAllControls: boolean;
}
